"use client";

import React, { useEffect, useState } from "react";
import abha from "@/public/images/home-images/abha.webp";
import Riyadh from "@/public/images/home-images/Riyadh.webp";
import Jeddah from "@/public/images/home-images/Jeddah.webp";
import Taif from "@/public/images/home-images/Taif.webp";
import ImageContainer from "./ImageContainer";
import { H2, H3 } from "../headers";
import { Carousel, CarouselContent, CarouselItem } from "../ui/carousel";
import Fade from "embla-carousel-fade";
import AutoPlay from "embla-carousel-autoplay";
import useSizes from "@/lib/window-sizes-hook";
import Container from "../container";
import { dir } from "i18next";
import { useLocale, useTranslations } from "next-intl";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const MostPopularSection = ({ className }: { className?: string }) => {
  const t = useTranslations();

  return (
    <Container className={className}>
      <div className="sm:text-center p-5 sm:p-10 space-y-3 sm:space-y-6">
        <H2 className="text-green-main font-semibold ">
          {t("mostPopularSection.title")}
        </H2>
        <H3 className="text-gray-light">{t("mostPopularSection.subtitle")}</H3>
      </div>
      <Places />
    </Container>
  );
};

export default MostPopularSection;

const Places = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const { maxLg } = useSizes();
  const locale = useLocale();
  const t = useTranslations();
  const isClient = useSelector((state: RootState) => state.isBrowser);

  useEffect(() => {
    setIsSmallScreen(maxLg && isClient);
  }, [maxLg, isClient]);

  if (isSmallScreen) {
    return (
      <Carousel
        opts={{ direction: dir(locale), loop: true }}
        plugins={[Fade(), AutoPlay({ delay: 3000 })]}
      >
        <CarouselContent className="h-[730px] max-lg:h-[350px]">
          {[
            { img: Jeddah, placeName: t("places.jeddah") },
            { img: abha, placeName: t("places.abha") },
            { img: Riyadh, placeName: t("places.riyadh") },
            { img: Taif, placeName: t("places.taif") },
          ].map((data, i) => (
            <CarouselItem key={i} className="!pr-0">
              <ImageContainer {...data} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    );
  }

  return (
    <div className="flex *:flex-1 h-[730px] max-sm:h-[350px] rounded-2xl overflow-hidden relative">
      {[
        { img: Jeddah, placeName: t("places.jeddah") },
        { img: abha, placeName: t("places.abha") },
        { img: Riyadh, placeName: t("places.riyadh") },
        { img: Taif, placeName: t("places.taif") },
      ].map((data, i) => (
        <ImageContainer key={i} {...data} />
      ))}
    </div>
  );
};
